import React, { FC } from 'react';
import { Card, CardContent, CardHeader, Typography } from '@material-ui/core';
import { useStyles } from './styles';

interface Props {
  title: string;
  value: number;
}

export const QuickReport: FC<Props> = ({ title, value }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardHeader title={title} />
      <CardContent>
        <Typography component="p" className={classes.percentContent}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};
